// Components
import FormLoginDialog from "@Settings/Layouts/FormLoginDialog";
import StepRouter from "@Settings/Layouts/FormVariants/StepRouter";
import ProviderLogin from "@Settings/components/AdministrationTools/KeyManagementSystem/sections/ProviderLogin";

// Types
import { AuthenticationType } from "@Settings/types/Common/auth";
import { TGetProviderList } from "@Settings/api/AdministrationTools/queries";
import { AuthRoleStatus, CustomCredentials, TSelectedProvider } from "@Settings/types/administrationTools/utils";

type ProviderSectionProps = Readonly<{
	isOpenDialog: boolean;
	loginError: boolean;
	loginErrorData: Error | null;
	isLoginSuccess: boolean;
	isSigningIn: boolean;
	selectedProvider: Partial<TSelectedProvider> | null;
	isLoadingProviders: boolean;
	isMutatingProvider: boolean;
	resetLoginError: () => void;
	providers: TGetProviderList[];
	// Callbacks
	onCloseDialog: () => void;
	onLogin: (credentials: CustomCredentials) => void;
	onLogout: () => void;
	onClickProviderLogin: () => void;
	onChangeProvider: (provider: Partial<TSelectedProvider>) => void;
}>;

export default function ProviderSection(props: ProviderSectionProps) {
	const {
		isOpenDialog,
		loginError,
		loginErrorData,
		isLoginSuccess,
		isSigningIn,
		selectedProvider,
		providers,
		isLoadingProviders,
		isMutatingProvider,
		resetLoginError,
		// Callbacks
		onCloseDialog,
		onLogin,
		onLogout,
		onChangeProvider,
		onClickProviderLogin,
	} = props;
	return (
		<>
			<FormLoginDialog
				isOpen={isOpenDialog}
				isError={loginError}
				error={loginErrorData}
				isSuccess={isLoginSuccess}
				headerImage={selectedProvider?.imageUrl}
				isSigningIn={isSigningIn}
				resetLoginError={resetLoginError}
				// Callbacks
				onSubmit={onLogin}
				onClose={onCloseDialog}
			>
				<StepRouter
					isMultiStep={Number(selectedProvider?.auth?.roles?.length) > 1}
					authType={selectedProvider?.authType as AuthenticationType}
					selectedProvider={selectedProvider as (Partial<TSelectedProvider> & { authRoleStatuses: AuthRoleStatus[] }) | null}
					isError={loginError}
					error={loginErrorData}
					isLoading={isSigningIn}
					disabled={isSigningIn}
					// Callbacks
					onLogout={onLogout}
					onChangeProvider={onChangeProvider}
				/>
			</FormLoginDialog>

			<ProviderLogin
				providers={providers ?? []}
				selectedProvider={selectedProvider}
				isLoading={isLoadingProviders || isSigningIn}
				isPending={isMutatingProvider}
				disabled={!selectedProvider}
				// Callbacks
				onLogin={onClickProviderLogin}
				onLogout={onLogout}
				onUpdateProvider={onChangeProvider}
			/>
		</>
	);
}
